import React from 'react';
import styled from 'styled-components';
import { Flex } from 'grid-styled';

const Header = styled.div`
    display: flex;
    align-items: center;
    font-weight: bold;
    margin: 0;
    padding: 5px;
    color: #fff;
    background-color: ${p => p.theme.colors.gray[0]};
    border-radius: 2px 2px 0px 0px;
    font-size: 14;
`;

const Panel = ({ title, children, ...props }) => (
    <Flex {...props} flexDirection="column" {...props}>
        {title && <Header>{title}</Header>}
        {children}
    </Flex>
);

Panel.Header = Header;

const StyledPanel = styled(Panel)`
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
    background-color: #fff;
`;

export default StyledPanel;



// WEBPACK FOOTER //
// ./src/uic/Panel.js